export const CASHBACK = 'CASHBACK_WALLET';
